import CustomHeader from '../../../../Components/AgGrid/CustomHeader';
import CreateColumn from '../../../../Services/agGrid/createColumn';

export const getColumnDefs1 = (props) => {
  return [
    CreateColumn('sheNm', '교육명', 'left', 250, false, false, false, 'text', {
      editable: false,
      cellClass: 'none-editable-cell',
    }),

    CreateColumn(
      'shePeriod',
      '기간',
      'left',
      250,
      false,
      false,
      false,
      'text',
      {
        editable: true,
        cellEditor: 'agTextCellEditor',
        headerComponent: CustomHeader,
        headerComponentParams: { required: false },
        cellStyle: {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
        },
      }
    ),

    CreateColumn(
      'sheTargetCount',
      '교육대상자',
      'right',
      180,
      false,
      false,
      false,
      'number',
      {
        editable: false,
        valueFormatter: (params) => params.value || 0,
        cellClass: 'none-editable-cell',
      }
    ),

    CreateColumn(
      'sheGraduate',
      '이수자',
      'right',
      180,
      false,
      false,
      false,
      'number',
      {
        editable: true,
        cellEditor: 'agNumberCellEditor',
        cellEditorParams: {
          onCellEditorCreated: (params) => {
            const getInput = () => {
              if (params.eInput) return params.eInput;
              return document.querySelector('input.ag-input-field-input');
            };

            const maxTargetCount = () =>
              Number(params.node?.data?.sheTargetCount) ?? 0;

            const setupInput = () => {
              const input = getInput();
              if (!input) return setTimeout(setupInput, 10);

              const handleKeyDown = (e) => {
                const allowedKeys = [
                  'Backspace',
                  'Delete',
                  'ArrowLeft',
                  'ArrowRight',
                  'ArrowUp',
                  'ArrowDown',
                  'Tab',
                  'Enter',
                  'Home',
                  'End',
                ];
                const isNumberKey = e.key >= '0' && e.key <= '9';
                if (
                  !isNumberKey &&
                  !allowedKeys.includes(e.key) &&
                  !e.ctrlKey &&
                  !e.metaKey
                ) {
                  e.preventDefault();
                  e.stopPropagation();
                  return false;
                }
              };

              const handleInput = () => {
                let val = input.value.replace(/[^0-9]/g, '');
                const maxVal = maxTargetCount();
                if (val !== '') {
                  const num = parseInt(val, 10);
                  if (!isNaN(num)) {
                    if (num > maxVal) val = String(maxVal);
                    else if (num > 2147483647) val = '2147483647';
                  }
                }
                if (val.length > 10) val = val.slice(0, 10);
                input.value = val;
              };

              input.addEventListener('keydown', handleKeyDown);
              input.addEventListener('input', handleInput);
            };

            setupInput();
          },
        },
        valueParser: (params) => {
          const raw = params.newValue?.toString().replace(/[^0-9]/g, '') || '';
          let parsed = parseInt(raw, 10);
          if (isNaN(parsed)) return null;
          const maxVal = Number(params.data?.sheTargetCount) ?? 0;
          const capped = Math.min(parsed, 2147483647, maxVal);
          return capped;
        },
        onCellValueChanged: (params) => {
          const targetCount = Number(params.data.sheTargetCount) || 0;
          const completerCount = Number(params.data.sheGraduate) || 0;
          let progressRate = 0;
          if (targetCount > 0 && completerCount > 0) {
            progressRate = (completerCount / targetCount) * 100;
          }
          params.data.graduateRate = Math.round(progressRate * 100) / 100;
          params.data.editYn = 'Y';
          params.api.refreshCells({
            rowNodes: [params.node],
            columns: ['graduateRate'],
          });
        },
        cellStyle: {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'right',
        },
      }
    ),

    CreateColumn(
      'graduateRate',
      '진행율(%)',
      'right',
      150,
      false,
      false,
      false,
      'number',
      {
        editable: false,
        headerComponent: CustomHeader,
        headerComponentParams: { required: false },
        valueGetter: (params) => {
          const targetCount = Number(params.data?.sheTargetCount) || 0;
          const completerCount = Number(params.data?.sheGraduate) || 0;
          if (targetCount > 0 && completerCount > 0) {
            const progressRate = (completerCount / targetCount) * 100;
            return Math.round(progressRate * 100) / 100;
          }
          return 0;
        },
        valueFormatter: (params) => {
          if (params.value === null || params.value === undefined) return '0%';
          return `${params.value}%`;
        },
        cellClass: 'none-editable-cell',
      }
    ),
  ];
};

const columnDefs = {
  getColumnDefs1,
};

export default columnDefs;
